export default __webpack_public_path__ + "static/media/Gloves of Bestial Rage.fade99d8.jpg";